<template>
  <div>
    <div class="s_bg">
      <div class="sea">
        <p>
          <b>热门关键词：</b>
          <router-link tag="a" :to="{ name: 'product', params: { id: 59,nid:2 }}">管焊机</router-link>
          <router-link tag="a" :to="{ name: 'product', params: { id: 62,nid:3 }}">管板焊机</router-link>
          <router-link tag="a" :to="{ name: 'product', params: { id: 63,nid:4 }}">自动焊专机</router-link>
        </p>
        <div class="s_b">
          <input type="text" v-model="sval" placeholder="请输入关键字" class="s_01" />
          <img src="../../static/images/s_s.gif" width="28" height="25" @click="tosearch()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "search",
  data() {
    return {
      sval: ""
    };
  },
  methods: {
    tosearch() {
      if (!this.sval.replace(/\s+/g, "")) {
        alert("请输入关键字~");
        return;
      }
      this.$router.push({
        name: "search",
        query: {
          sval: this.sval
        }
      });
    }
  }
};
</script>
